export const PATHS = {
  home: '/',
  mileage: '/mileage',
  review: '/reviews',
};

export const mileageRegex = /\/mileage\/?$/;
